import * as constActions from './SharesConstsActions';
import initialState from './SharesInitialState';

export default function SharesReducer(state = initialState, action) {
  switch (action.type) {
    case constActions.GET_SHARES_COLUMNS_REQUEST: {
      return state;
    }

    case constActions.GET_SHARES_COLUMNS_SUCCESS: {
      return Object.assign({}, state, {
        columns: action.results
      });
    }

    case constActions.GET_SHARES_COLUMNS_FAILURE: {
      return state;
    }

    case constActions.GET_SHARES_REQUEST: {
      return state;
    }

    case constActions.GET_SHARES_FAILURE: {
      return state;
    }

    case constActions.GET_INITIAL_SHARES_SUCCESS: {
      return Object.assign({}, state, {
        results: [...action.results]
      });
    }

    case constActions.GET_SHARES_SUCCESS: {
      return Object.assign({}, state, {
        results: [...state.results, ...action.results]
      });
    }

    case constActions.SAVE_SHARES_SEARCH_PARAMETERS: {
      return Object.assign({}, state, {
        parameters: action.parameters
      });
    }

    case constActions.SELECT_SHARES_SUCCESS: {
      return Object.assign({}, state, {
        selectedShares: JSON.parse(JSON.stringify(action.selectedShares))
      });
    }

    case constActions.SELECT_ALL_SHARES_SUCCESS: {
      return Object.assign({}, state, {
        isSelectAllChecked: action.isSelectAllChecked
      });
    }

    default:
      return state;
  }
}
